module.exports = __webpack_public_path__ + "2f9e1923847446347776a73ca0fbb854.png";